var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCalendar = function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 39 43",
    fill: "#B8B8B8",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.125 23.5H19.5v10.625h10.625V23.5ZM28 .125v4.25H11V.125H6.75v4.25H4.625c-2.359 0-4.229 1.912-4.229 4.25l-.021 29.75a4.249 4.249 0 0 0 4.25 4.25h29.75a4.262 4.262 0 0 0 4.25-4.25V8.625a4.262 4.262 0 0 0-4.25-4.25H32.25V.125H28Zm6.375 38.25H4.625V15h29.75v23.375Z"
  })));
};
export default SvgCalendar;